import React from "react";
import Header from "./Header";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

const parseInstanceSettings = () => {
  try {
    const raw = localStorage.getItem("instance_settings");
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    console.error("Unable to parse instance settings:", error);
    return {};
  }
};

const isSectionEnabled = (sections = {}, key) => {
  if (sections && Object.prototype.hasOwnProperty.call(sections, key)) {
    return !!sections[key];
  }
  return true;
};

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isHeaderActive, setIsHeaderActive] = useState(false);
  const [isResponsive, setIsResponsive] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  let userName= localStorage.getItem("currentUser");
  let supplierName= localStorage.getItem("supplierName");
  const [isStatementActive, setIsStatementActive] = useState(false);

  const settings = parseInstanceSettings();
  const sectionSettings = settings.sections || {};
  const adminLinks = [
    {
      path: "/Home",
      label: "Milk",
      icon: 'milk',
      available: isSectionEnabled(sectionSettings, 'milk'),
      available: true,
    },
    {
      path: "/Profile",
      label: "Profile",
      icon: 'users',
      available: true,
    },
    {
      path: "/AppField",
      label: "Appfield",
      icon: 'instances',
      available: true,
    },
    {
      path: "/Documents",
      label: "Docs",
      icon: 'docs',
      available: true,
    },
    {
      path: "/Forecast",
      label: "Forecast",
      icon: 'forecast',
      available: true,
    },
    {
      path: "/Forms",
      label: "Forms",
      icon: 'forms',
      available: true,
    },
    {
      path: "/Compare",
      label: "Compare",
      icon: 'compare',
      available: true,
    },
    {
      path: "/AdminNotes",
      label: "Notes",
      icon: 'message',
      available: true,
    },
  ];
  const userLinks = [
    {
      path: "/Home",
      label: "Milk",
      icon: 'milk',
      available: isSectionEnabled(sectionSettings, 'milk'),
    },
    {
      path: "/Compare",
      label: "Compare",
      icon: 'compare',
      available: isSectionEnabled(sectionSettings, 'compare'),
    },
    {
      path: "/Statement",
      label: isStatementActive ? "Statement" : "Statement",
      icon: 'statements',
      available: isSectionEnabled(sectionSettings, 'statements'),
    },
    {
      path: "/Documents",
      label: "Docs",
      icon: 'docs',
      available: isSectionEnabled(sectionSettings, 'docs'),
    },
    {
      path: "/Forms",
      label: "Forms",
      icon: 'forms',
      available: isSectionEnabled(sectionSettings, 'forms'),
    },
    {
      path: "/Forecast",
      label: "Forecast",
      icon: 'forecast',
      available: isSectionEnabled(sectionSettings, 'forecast'),
    },
  ];
  useEffect(() => {
    setIsStatementActive(location.pathname === "/Statement");
  }, [location]);
  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    if (token) {
      const userRole = role;;
      setIsAdmin(userRole && userRole.toLowerCase().includes("admin"));
    } else {
      console.error("Token not found in localStorage.");
    }
  }, []);

  const navLinks = isAdmin ? adminLinks : userLinks;

  const handleMyFunction = () => {
    const x = document.getElementById("myTopnav");
    x.className = isResponsive ? "topnav" : "topnav responsive";
    setIsResponsive((prevState) => !prevState);
  };

  const handleTopnavClick = () => {
    setIsHeaderActive((prevState) => !prevState);
  };
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("supplierId");
    localStorage.removeItem("supplierName");
    localStorage.removeItem("currentUser");
    localStorage.removeItem("instance_settings");
    localStorage.removeItem("role");
    // sessionStorage.removeItem("token", "supplierId");
    setIsAdmin(false);
    const { protocol, host } = window.location;
    window.location.href = `${protocol}//${host}/`;
  };
  const handleStatementClick = () => {
    setIsStatementActive(!isStatementActive);
    navigate(isStatementActive ? "" : "/Statement");
  };
  return (
    <>
      <div id="header-wrapper" className={(isHeaderActive ? "activeHeader" : "") + ' ' + (isAdmin ? 'header-admin' : '')}>
        <Header />
        {isAdmin && location.pathname !== "/Search" ? (
          <div id="user" className="chosen-user-message">
            <div className="chosen-user-message__icon">
              <i className="uicon-users" />
            </div>
            <div className="chosen-user-message__content">
              <span className="chosen-user-message__label">Viewing supplier</span>
              <strong className="chosen-user-message__value">
                {supplierName || "Joe Bloggs"}
              </strong>
              <span className="chosen-user-message__meta">ID {userName || "0041500"}</span>
            </div>
            <button className="chosen-user-message__action" onClick={() => navigate("/Search")}>
              Change
            </button>
          </div>
        ) : null}

      </div>
      <div className="uds-nav-bar">
        <ul>
              {navLinks
                .filter((link) =>
                  link.available === undefined ? true : link.available
                )
                .map((link) => (
              <li
                key={link.label}
                controllername={link.controllername}
                onClick={
                  link.path === "/Statement"
                    ? handleStatementClick
                    : () => navigate(link.path)
                }
                className={(location.pathname === link.path || (location.pathname == '/Results' && link.path == '/Home') || (location.pathname.search('/Statement') > -1 && link.path == '/Statement') ) ? "active" : ""}
              >
                <a>
                  <span className="uds-nav-icon"><i className={link.icon ? `uicon-${link.icon}` : ''}></i></span>
                  <span>
                    {link.path === "/Statement"
                      ? isStatementActive
                        ? "Statement"
                        : "Statement"
                      : link.label}
                  </span>
                </a>
              </li>
            ))}
            <li onClick={handleLogout}>
              <a>
                <span className="uds-nav-icon"><i className="uicon-exit"></i></span>
                <span>Exit</span>
              </a>
            </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
